module.exports = __webpack_public_path__ + "static/media/desktopScreenshot10.1bc65f46.jpg";